import AppEnvService from '@core/services/utils/appEnvService';

/**
 * Numéro de build et détection des déploiements (calqué sur Pappus).
 *
 *  - Le build du frontend (commit court + date) est injecté par quasar.config.js
 *    (constantes Vite __APP_BUILD__ / __APP_BUILD_DATE__) ; celui du backend vient de
 *    /api/appEnv/load (APP_BUILD_BO / APP_BUILD_BO_DATE).
 *  - checkForUpdate() : le backend lit le build.json servi par nginx toutes les minutes
 *    et diffuse FRONTEND_UPDATE ; à sa réception, si le commit diffère, on force la
 *    vérification du service worker, qui s'active et recharge la page
 *    (src-pwa/custom-service-worker.js).
 */
class AppUpdateService {

  // Constantes injectées par Vite (define, quasar.config.js) — pas process.env : dans les
  // modules hors du shell, vite-plugin-node-polyfills le remplace par un objet à env vide.
  get frontBuild() {
    return typeof __APP_BUILD__ !== 'undefined' ? __APP_BUILD__ : '';
  }

  get frontBuildDate() {
    return typeof __APP_BUILD_DATE__ !== 'undefined' ? __APP_BUILD_DATE__ : '';
  }

  get backBuild() {
    return AppEnvService.getEnv('APP_BUILD_BO') || '';
  }

  get backBuildDate() {
    return AppEnvService.getEnv('APP_BUILD_BO_DATE') || '';
  }

  /** Démarrage du serveur : affiché quand la date de build est inconnue (backend lancé hors CI). */
  get backStartedAt() {
    return AppEnvService.getEnv('APP_BO_STARTED') || '';
  }

  /** Un nouveau frontend a été annoncé : vérifier le service worker si le build diffère. */
  checkForUpdate(commit) {
    if (!commit || commit === this.frontBuild || !('serviceWorker' in navigator)) return;
    navigator.serviceWorker.getRegistration()
      .then((registration) => registration && registration.update())
      .catch(() => {});
  }

  /** « 6 octobre 2026 à 14:05 » (heure de Paris), '' si date absente/invalide. */
  formatDate(iso) {
    const d = iso ? new Date(iso) : null;
    return d && !isNaN(d) ? d.toLocaleString('fr-FR', {
      day: 'numeric', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Paris'
    }) : '';
  }
}

export default new AppUpdateService();
